<template>
  <v-dialog v-model="show"
            fullscreen scrollable
            :transition="false"
  >
    <v-sheet id="menu-dialog-contents" :width="750" :max-width="750"
             class="mx-auto"
    >
      <v-toolbar height="120">
        <v-btn icon width="80" height="80"
               disabled
        />

        <v-toolbar-title>메뉴</v-toolbar-title>

        <v-btn icon
               width="80"
               height="80"
               @click="show = false"
        >
          <v-icon size="50">
            $close
          </v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-0">
        <v-container class="menu-container">
          <v-card-title>컬러렌즈</v-card-title>

          <v-row class="menu-row" no-gutters>
            <v-col cols="4">
              <v-sheet class="menu-link__has-image" role="button" @click="goToLink({ name: 'roundup.result', query: {uc: 'UC001'} })">
                <img :src="require('@/assets/images/ico-r1.png')" alt="원데이">
                <div class="menu-link-image-desc">
                  원데이
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="4">
              <v-sheet class="menu-link__has-image" role="button" @click="goToLink({ name: 'roundup.result', query: {uc: 'UC002,UC003'} })">
                <img :src="require('@/assets/images/ico-r2.png')" alt="2주/한달용">
                <div class="menu-link-image-desc">
                  2주/한달용
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="4">
              <v-sheet class="menu-link__has-image" role="button" @click="goToLink({ name: 'roundup.result', query: {lm: 'LM002,LM003'} })">
                <img :src="require('@/assets/images/ico-r3.png')" alt="프리미엄">
                <div class="menu-link-image-desc">
                  프리미엄
                </div>
              </v-sheet>
            </v-col>
          </v-row>

          <v-row class="menu-row" no-gutters>
            <v-col cols="4">
              <v-sheet class="menu-link__has-image" role="button" @click="goToLink({ name: 'roundup.result', query: {uc: 'UC004,UC005'} })">
                <img :src="require('@/assets/images/ico-r4.png')" alt="장기착용">
                <div class="menu-link-image-desc">
                  장기착용
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="4">
              <v-sheet class="menu-link__has-image" role="button" @click="goToLink({ name: 'roundup.result', query: {asmYn: 'Y'} })">
                <img :src="require('@/assets/images/ico-r5.png')" alt="난시용">
                <div class="menu-link-image-desc">
                  난시용
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="4">
              <v-sheet class="menu-link__has-image" role="button" @click="goToLink({ name: 'roundup.result', query: {cd: 'CD005'} })">
                <img :src="require('@/assets/images/ico-r6.png')" alt="코스프레 렌즈">
                <div class="menu-link-image-desc">
                  코스프레 렌즈
                </div>
              </v-sheet>
            </v-col>
          </v-row>

          <v-row class="menu-row" no-gutters>
            <v-col cols="6">
              <v-sheet class="menu-text-link" role="button" @click="goToLink({ name: 'roundup.result', query: {cg: 'CG001'} })">
                투명렌즈
              </v-sheet>
            </v-col>
            <v-col cols="6">
              <v-sheet class="menu-text-link" role="button" @click="goToLink({ name: 'roundup.result', query: {prdDivCd: 'PD002,PD003,PD004,PD005,PD006'} })">
                관리용품
              </v-sheet>
            </v-col>
          </v-row>
        </v-container>

        <v-container class="menu-container">
          <v-card-title>커뮤니티</v-card-title>

          <v-row class="menu-row" no-gutters>
            <v-col cols="4">
              <v-sheet class="menu-link" role="button" @click="goToLink('event')">
                이벤트
              </v-sheet>
            </v-col>
            <v-col cols="4">
              <v-sheet class="menu-link" role="button" @click="goToLink('notice.list')">
                공지사항
              </v-sheet>
            </v-col>
            <v-col cols="4">
              <v-sheet class="menu-link" role="button" @click="goToLink('faq')">
                FAQ
              </v-sheet>
            </v-col>
          </v-row>

          <v-row class="menu-row" no-gutters>
            <v-col cols="4">
              <v-sheet class="menu-link" role="button" @click="goToLink('qna')">
                문의하기
              </v-sheet>
            </v-col>
            <v-col cols="4">
              <v-sheet class="menu-link" role="button" @click="goToLink('franchise-info')">
                가맹안내
              </v-sheet>
            </v-col>
            <v-col cols="4">
              <v-sheet class="menu-link" role="button" @click="goToLink('franchise.list')">
                매장찾기
              </v-sheet>
            </v-col>
          </v-row>
        </v-container>

        <v-container class="menu-container">
          <v-card-title>안 건강 클리닉</v-card-title>

          <v-row class="menu-row" no-gutters>
            <v-col cols="6">
              <v-sheet class="menu-image-link" role="button" @click="goToLink('clinic.campaign.past')">
                <img :src="require('@/assets/images/gnb-lk1.1031c152.jpg')" alt="건강한 눈 캠페인">
              </v-sheet>
            </v-col>
            <v-col cols="6">
              <v-sheet class="menu-image-link" role="button" @click="goToLink('clinic.manual')">
                <img :src="require('@/assets/images/gnb-lk2.962e1b2d.jpg')" alt="올바른 렌즈 사용법">
              </v-sheet>
            </v-col>
          </v-row>

          <v-row class="menu-row" no-gutters>
            <v-col cols="6">
              <v-sheet class="menu-text-link" role="button" @click="goToLink('clinic.vision-center')">
                정밀시력 검사
              </v-sheet>
            </v-col>
            <v-col cols="6">
              <v-sheet class="menu-text-link" role="button" @click="goToLink('clinic.reservation')">
                정밀시력 검사 예약
              </v-sheet>
            </v-col>
          </v-row>
        </v-container>

        <v-card-title class="menu-card-title">
          브랜드
        </v-card-title>

        <v-container class="grid-table-menu">
          <v-row>
            <v-col cols="6" role="button" @click="goToLink('brand.olens')">
              Brand Identity
            </v-col>
            <v-col cols="6" role="button" @click="goToLink('brand.muse')">
              OLENS MUSE
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" role="button" @click="goToLink('brand.academy')">
              아카데미
            </v-col>
            <v-col cols="6" role="button" @click="goToLink('brand.vision')">
              사회공헌
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-sheet>

    <service-prepare-dialog v-if="showServicePrepareDialog" v-model="showServicePrepareDialog" />
  </v-dialog>
</template>

<script>

import ServicePrepareDialog from '@/components/common/dialogs/ServicePrepareDialog';
import { goToLinkMixin } from '@/mixins/goToLinkMixin';

export default {
  name: 'MenuDialog',
  components: { ServicePrepareDialog },
  mixins: [goToLinkMixin],
  props: {
    value: { type: Boolean, default: false },
  },
  data: () => ({
    showServicePrepareDialog: false,
  }),
  computed: {
    show: {
      get () {
        return this.value;
      },
      set (value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {},
};
</script>
